import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://martascharle.com';

const SEO = ({ title, description, image, url, type = 'website' }) => {
  const fullTitle = title ? `${title} | Marta Scharle` : 'Marta Scharle - Travel Writer';
  const defaultDesc = 'Travel journalist and photographer sharing stories from Nepal and the Himalayas';
  const desc = description || defaultDesc;
  const ogImage = image || `${SITE_URL}/everest.png`;
  const canonical = url ? `${SITE_URL}${url}` : SITE_URL;

  return (
    <Helmet
      title={fullTitle}
      meta={[
        { name: 'description', content: desc },
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: desc },
        { property: 'og:image', content: ogImage },
        { property: 'og:url', content: canonical },
        { property: 'og:type', content: type },
        { property: 'og:site_name', content: 'Marta Scharle' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: desc },
        { name: 'twitter:image', content: ogImage },
      ]}
      link={[{ rel: 'canonical', href: canonical }]}
    />
  );
};

export default SEO;
